import { render } from "./TrendingApps.vue?vue&type=template&id=6a5ff483&scoped=true"
import script from "./TrendingApps.vue?vue&type=script&lang=js"
export * from "./TrendingApps.vue?vue&type=script&lang=js"

import "./TrendingApps.vue?vue&type=style&index=0&id=6a5ff483&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5ff483"]])

export default __exports__